import { JSONSchemaType } from 'ajv'

export interface ICustomerPermissionFormData {
  id: string
  keyPermission: string
  sellerId: string
  buyerId: string
  isPermitted: boolean
}

const CustomerPermissionSchema: JSONSchemaType<ICustomerPermissionFormData> = {
  type: 'object',
  properties: {
    keyPermission: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    sellerId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    buyerId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    isPermitted: {
      type: 'boolean',
    },
    id: {
      type: 'string',
    },
  },
  required: ['keyPermission', 'sellerId', 'buyerId'],
  additionalProperties: false,
}

export default CustomerPermissionSchema
